import { useEffect, useRef, useState } from 'react';
import { useCueDiagnostics } from './useCueDiagnostics';

// Returns true for ~1s each time a Cue relay lands for `channelId`, so a
// dot / icon can pulse when a signal arrives ("like income"). Reads the
// shared diagnostics store's lastActivityAt map (see diagnostics.ts) and
// watches the timestamp for this one channel; a change flips the flag on,
// a timer flips it back off. Passing an empty/undefined channelId just
// stays false.
export function useActivityBlink(channelId: string | undefined): boolean {
  const { lastActivityAt } = useCueDiagnostics();
  const at = channelId ? lastActivityAt[channelId] : undefined;
  const [blinking, setBlinking] = useState(false);
  // Ignore the value present on first mount - only a fresh relay after the
  // component is on screen should pulse it.
  const seenRef = useRef<number | undefined>(at);

  useEffect(() => {
    if (at === undefined || at === seenRef.current) return;
    seenRef.current = at;
    setBlinking(true);
    const timer = setTimeout(() => setBlinking(false), 1000);
    return () => clearTimeout(timer);
  }, [at]);

  return blinking;
}
